import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {CrystalClearFrontUrl} from "../../../../shared/pages/crystal-clear-front-url";
import {
  ReportTotalResidualFormComponent
} from "../report-total-residual-adjust-form/report-total-residual-form.component";
import {CcFormComponent} from "../../../../crystal-elements/form-dialog/form/cc-form.component";

@Component({
  selector: 'app-archive-report-total-residual-adjust-button',
  templateUrl: './report-total-residual-adjust-button.component.html',
  styleUrls: ['./report-total-residual-adjust-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTotalResidualAdjustButtonComponent extends CcBaseComponent {

  @Input()
  buttonTitle: string = 'page_title.archive.total_residual_adjust';
  @Input()
  transPartKey: string = 'total-residual';
  CrystalClearFrontUrl = CrystalClearFrontUrl;

  @Input()
  origins: string[];
  inProgressCount: number = 0;
  dialogFormVisible: boolean =false;

  @ViewChild('ccRTRForm')
  ccRTRForm: ReportTotalResidualFormComponent;

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

  }

}
